import React from "react";
import { render } from "react-dom";
import Locator from "./branch_locator/locator";

render(React.createElement(Locator), document.querySelector(".branch-locator"));
